<template>
    <div class="card" style="min-height: calc(100vh - 180px)">
        <div class="bg-blue-light p-1">
            <TitleButton
                btnTitle="List"
                :showBtn="true"
                :showAddNew="false"
                title="Sales Invoice Edit"
                @onClickCloseButton="navigateToListPage"
            >
                <template #extra-btn>
                    <button
                        v-if="route.params.salesId && formData.template_log_exists === false"
                        @click="onClickToMakeTemplate"
                        class="btn btn-primary waves-effect waves-float waves-light"
                    >Make template
                    </button>
                    <button
                        v-if="route.params.salesId && formData.template_log_exists"
                        class="btn btn-outline-secondary waves-effect waves-float waves-light"
                        @click="onRemoveTemplate"
                        :disabled="loader"
                    >Cancel Template
                    </button>
                </template>
            </TitleButton>

            <div class="row mt-2 gy-1">
                <div class="col-md-3">
                    <label class="form-label">Invoice Date</label>
                    <input
                        class="form-control invoice-edit-input date-picker flatpickr-input flatpickr-mobile"
                        tabindex="1"
                        type="date"
                        placeholder=""
                        v-model="formData.date"
                    >
                </div>
                <div v-if="isItem && ! formData.challan_id" class="col-md-3">
                    <label class="form-label" for="sales-barcode-scan">Barcode / SKU</label>
                    <BarcodeScanInput
                        input-id="sales-barcode-scan"
                        :additional-query="scanQuery"
                        :disabled="! formData.location_id"
                        :placeholder="scanPlaceholder"
                        not-found-message="No stock in selected warehouse for barcode / SKU"
                        @scanned="onBarcodeScanned"
                    />
                </div>
                <div class="col-md-3" v-if="false">
                    <label class="form-label">Invoice No</label>
                    <div class="d-flex align-items-center justify-content-md-end mb-1">
                        <div class="input-group input-group-merge invoice-edit-input-group">
                            <div class="input-group-text">
                                <span>{{ prefix }}-</span>
                            </div>
                            <input type="number" min="1" class="form-control invoice-edit-input" placeholder=""
                                   v-model="serial">
                        </div>
                    </div>
                </div>
            </div>
            <div class="row gy-1">
                <div class="col-md-3">
                    <div class="d-flex align-items-center justify-content-between filter-label" style="height: 25px">
                        <label for="colFormLabel" class="col-form-label">Party: </label>
                        <span class="filter-search-icon cursor-pointer" @click="onOpenContactSearchModal('party')">
                            <i class="fas fa-search"></i>
                        </span>
                    </div>
                    <AsyncSelect
                        placeholder="Select Party"
                        v-model="contactProfile"
                        :api-service="fetchContactProfiles"
                        :additional-query="{ with_mobile: 1, roles: 'customer' }"
                        :format-label="formatPatientLabel"
                    />
                  <div v-if="rewardBalance" class="d-inline-block mx-1">
                    <span> Reward Balance: </span>
                    <span> <strong> {{ rewardBalance }} </strong> </span>
                  </div>
                </div>
                <div class="col-md-3">
                    <label class="form-label">Project</label>
                    <v-select
                        placeholder="Select Project"
                        v-model="formData.project_id"
                        :options="projects"
                        label="name"
                        :reduce="name => name.id"
                    />
                </div>
                <div class="col-md-3">
                    <label class="form-label">Business Unit</label>
                    <v-select
                        placeholder="Select Business"
                        v-model="formData.business_id"
                        :options="business"
                        label="name"
                        :reduce="name => name.id"
                    />
                </div>
                <div class="col-md-3">
                    <label class="form-label">Cost Centre</label>
                    <v-select
                        placeholder="Select Cost Centre"
                        v-model="formData.cost_centre_id"
                        :options="costCentres"
                        label="name"
                        :reduce="name => name.id"
                    />
                </div>
                <div class="col-md-3">
                    <label class="form-label">Ship from (Warehouse)</label>
                    <v-select
                        placeholder="Select Warehouse Location"
                        v-model="formData.location_id"
                        :options="locations"
                        label="text"
                        :reduce="text => text.id"
                        disabled=""
                    />
                </div>
                <div class="col-md-3">
                    <label class="form-label">Receivable Accounts</label>
                    <v-select
                        placeholder="Account Head"
                        v-model="formData.account_head_id"
                        :options="accountPayable"
                        label="name"
                        :reduce="name => name.id"
                    />
                </div>
                <div class="col-md-3">
                    <label class="form-label">VAT/GST Accounts</label>
                    <v-select
                        placeholder="VAT/GST Payable Account Head"
                        v-model="formData.vat_payable_account_head_id"
                        :options="vatPayable"
                        label="name"
                        :reduce="name => name.id"
                    />
                </div>
                <div class="col-md-3">
                    <label class="form-label">Order No/PI No</label>
                    <input
                        class="form-control invoice-edit-input date-picker flatpickr-input flatpickr-mobile"
                        tabindex="1"
                        type="text"
                        placeholder="Please add order number"
                        v-model="formData.order_number"
                    >
                </div>
                <div class="col-md-3">
                    <div class="d-flex align-items-center justify-content-between filter-label" style="height: 25px">
                        <label for="colFormLabel" class="col-form-label">Sales Person</label>
                        <span class="filter-search-icon cursor-pointer" @click="onOpenContactSearchModal('sales_person')">
                            <i class="fas fa-search"></i>
                        </span>
                    </div>
                    <AsyncSelect
                        placeholder="Select Sales Person"
                        v-model="salesPerson"
                        :api-service="fetchContactProfiles"
                        :additional-query="{ with_mobile: 1 }"
                        :format-label="formatPatientLabel"
                    />
                </div>
                <div class="col-md-3">
                    <label class="form-label">Commission %</label>
                    <input
                        class="form-control invoice-edit-input date-picker flatpickr-input flatpickr-mobile"
                        tabindex="1"
                        type="number"
                        placeholder="Please add commission %"
                        v-model="formData.commission_percent"
                    >
                </div>
                <div class="col-md-3">
                    <label class="form-label">Commission Amount</label>
                    <input
                        class="form-control invoice-edit-input date-picker flatpickr-input flatpickr-mobile"
                        tabindex="1"
                        type="number"
                        placeholder="Please add commission amount"
                        v-model="formData.commission_amount"
                    >
                </div>
                <div class="col-md-3">
                    <label class="form-label">LC No</label>
                    <input
                        class="form-control invoice-edit-input date-picker flatpickr-input flatpickr-mobile"
                        tabindex="1"
                        type="text"
                        placeholder="Please add LC number"
                        v-model="formData.lc_number"
                    >
                </div>
            </div>
        </div>

        <div class="px-2">
            <ul class="nav nav-tabs" role="tablist">
                <li class="nav-item">
                    <a @click="formData.has_item_detail = true" :class="{'active' : formData.has_item_detail, 'disabled': !!formData.challan_id}" class="nav-link" data-bs-toggle="tab"  aria-controls="home" role="tab" aria-selected="true">Item Details</a>
                </li>
                <li class="nav-item">
                    <a @click="formData.has_item_detail = false" :class="{'active' : !formData.has_item_detail, 'disabled': !!formData.challan_id}" class="nav-link" data-bs-toggle="tab" aria-controls="profile" role="tab" aria-selected="false">Accounts Details</a>
                </li>
            </ul>
        </div>

        <div class="px-3" v-if="loader === false">
            <Invoice
                class="mt-2"
                v-for="(data, index) in accountsDetails"
                :key="index"
                :index="index"
                :data="data"
                :products="products"
                :accountHeads="accountHeads"
                :vatRate="vatRate"
                :isItem="isItem"
                :locationId="formData.location_id"
                :business="business"
                :projects="projects"
                :costCentres="costCentres"
                :contact-profile-id="selectedCustomerId"
                @onClose="removeBill"
                @offerLoading="onOfferLoading"
                :is-edit="true"
            />
            <Invoice
                class="mt-2"
                v-for="(data, index) in itemsDetails"
                :key="data.row_key || index"
                :index="index"
                :data="data"
                :products="products"
                :accountHeads="accountHeads"
                :vatRate="vatRate"
                :isItem="isItem"
                :locationId="formData.location_id"
                :business="business"
                :projects="projects"
                :costCentres="costCentres"
                :contact-profile-id="selectedCustomerId"
                @onClose="removeBill"
                @offerLoading="onOfferLoading"
                :is-edit="data.product && data.product.product_type !== 'services'"
            />
        </div>

        <div class="px-2 mt-2">
            <button @click="addNewBill" class="btn btn-primary" v-if="!formData.challan_id">Add line</button>
        </div>

        <div class="px-2">
            <div class="row justify-content-between mt-2">
                <div class="col-12 col-sm-5">
                    <fieldset v-if="loader === false" :disabled="receiptLocked" :class="{ 'receipt-locked': receiptLocked }">
                        <MoneyReceiptForm :grand-total="grandTotal" />
                    </fieldset>
                    <small v-if="receiptLocked" class="text-danger">
                        This money receipt cannot be edited from the invoice.
                    </small>
                </div>
                <div class="col-12 col-sm-4">
                    <div class="row">
                        <div class="col-12">
                            <div class="mb-1 row">
                                <div class="col-sm-5">
                                    <label class="col-form-label" for="first-name">Sub total</label>
                                </div>
                                <div class="col-sm-7">
                                    <input
                                        v-model="subTotal"
                                        readonly
                                        type="text"
                                        class="form-control text-right"
                                    >
                                </div>
                            </div>
                        </div>
                        <div class="col-12">
                            <div class="mb-1 row">
                                <div class="col-sm-5">
                                    <label class="col-form-label" for="first-name">VAT/GST</label>
                                </div>
                                <div class="col-sm-7">
                                    <input
                                        v-model="totalVAT"
                                        readonly
                                        type="text"
                                        class="form-control text-right"
                                    >
                                </div>
                            </div>
                        </div>
                        <div class="col-12">
                            <div class="mb-1 row">
                                <div class="col-sm-5">
                                    <label class="col-form-label" for="first-name">Total</label>
                                </div>
                                <div class="col-sm-7">
                                    <input
                                        v-model="beforeAdjTotal"
                                        readonly
                                        type="text"
                                        class="form-control text-right"
                                        @click="openAdvanceModal"
                                    >
                                </div>
                            </div>
                        </div>
                        <div class="col-12">
                            <div class="mb-1 row">
                                <div class="col-sm-5">
                                    <label class="col-form-label" for="first-name">Advance Adjustment Amount</label>
                                </div>
                                <div class="col-sm-7">
                                    <input
                                        v-model="formData.advance_amount"
                                        readonly
                                        type="text"
                                        class="form-control text-right"
                                    >
                                </div>
                            </div>
                        </div>
                        <div class="col-12">
                            <div class="mb-1 row">
                                <div class="col-sm-5">
                                    <label class="col-form-label" for="first-name">Total</label>
                                </div>
                                <div class="col-sm-7">
                                    <input
                                        v-model="total"
                                        readonly
                                        type="text"
                                        class="form-control text-right"
                                    >
                                </div>
                            </div>
                        </div>
                        <div class="col-12">
                            <div class="mb-1 row">
                                <div class="col-sm-5">
                                    <label class="col-form-label" for="first-name">Discount / Round up Adj</label>
                                </div>
                                <div class="col-sm-7">
                                    <input
                                        v-model.trim="formData.adjustment_amount"
                                        type="number"
                                        class="form-control discount-adj ml-auto text-right"
                                        placeholder="amount" :min="0"
                                    >
                                </div>
                            </div>
                        </div>
                        <div class="col-12" v-if="discountAmount > 0">
                            <div class="mb-1 row">
                                <div class="col-sm-5">
                                    <label class="col-form-label" for="first-name">Select discount head</label>
                                </div>
                                <div class="col-sm-7">
                                    <v-select
                                        placeholder="Select Discount Head"
                                        v-model="formData.discount_head_id"
                                        :options="salesAccountHeads"
                                        label="name"
                                        :reduce="name => name.id"
                                    />
                                </div>
                            </div>
                        </div>
                        <div class="col-12">
                          <div class="mb-1 row">
                            <div class="col-sm-5">
                              <label class="col-form-label" for="first-name">Reward Point</label>
                            </div>
                            <div class="col-sm-7">
                              <input
                                  v-model.trim="formData.points_redeemed"
                                  type="number" class="form-control text-right"
                                  placeholder="amount" :min="0"
                              >
                            </div>
                          </div>
                        </div>

                      <div class="col-12" v-if="pointsRedeemed > 0">
                        <div class="mb-1 row">
                          <div class="col-sm-5">
                            <label class="col-form-label" for="first-name">Reward Point Head</label>
                          </div>
                          <div class="col-sm-7">
                            <v-select
                                placeholder="Select Head"
                                v-model="formData.liability_head_id"
                                :options="rewardPointsAccountHeads"
                                label="name"
                                :reduce="name => name.id"
                            />
                          </div>
                        </div>
                      </div>

                        <div class="col-12">
                            <div class="mb-1 row">
                                <div class="col-sm-5">
                                    <label class="col-form-label" for="first-name">Net Bill</label>
                                </div>
                                <div class="col-sm-7">
                                    <input
                                        v-model.trim="grandTotal"
                                        type="number" class="form-control discount-adj ml-auto text-right"
                                        placeholder="amount" :min="0"
                                        @keyup="updateAdjustmentAmount"
                                    >
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="col-12 px-2">
            <div class="mb-1">
                <label class="form-label" for="description">Memo</label>
                <vField
                  as="textarea"
                  name="description"
                  v-model="formData.description"
                  class="form-control"
                />
            </div>
        </div>

        <div class="pb-5 px-2 mt-4">
            <div class="d-flex flex-wrap gap-1 gy-2">
                <button :disabled="saveButtonLoader || saveNewButtonLoader || isOfferLoading" @click="handleSubmit(true)" class="btn btn-primary">
                  Update
                </button>
                <button :disabled="productLoader" @click="navigateToListPage" class="btn btn-outline-secondary">Cancel</button>
            </div>
        </div>
         <Loader v-if="loader"/>

        <ContactDropdownFilter
            v-if="store.state.isModalOpenThree"
            @onSearchContact="onSearchContact"
            type="customer"
        />

        <AddTempleModal
            v-if="store.state.isModalOpenTwo"
            modalOpen="isModalOpenTwo"
            :templateableId="parseInt(route.params.salesId)"
            templateType="sale"
            @onSubmit="changeTemplateStatus"
        />
        <AdvanceReceiptSelectionModal
            v-if="store.state.isAdvanceModalOpen"
            :receipts="advanceReceiptList"
            :total="parseFloat(beforeAdjTotal)"
        />
    </div>
</template>

<script setup>
import { ref, inject, onMounted, computed, watch, provide, nextTick } from 'vue'
import {vatRate} from '@/data/inventory.js'
import { useRouter, useRoute } from 'vue-router'
import handlePurchase from '@/services/modules/purchase'
import handleCBusinesses from '@/services/modules/businesses'
import handleBusinessesLocations from '@/services/modules/businessesLocations'
import handleContact from '@/services/modules/contact'
import handleProjects from "@/services/modules/procurement/project";
import handleCostCentres from "@/services/modules/ngo/costCentre";
import Loader from '@/components/atom/LoaderComponent'
import TitleButton from '@/components/atom/TitleButton'
import Invoice from '@/components/molecule/company/inventory/sales/Invoice.vue'
import { editVoucherNumber } from "@/services/utils/voucherNumberGenerator";
import AsyncSelect from "@/components/molecule/input-field/AsyncSelect.vue";
import ContactDropdownFilter from "@/components/atom/Contact/ContactDropdownFilter.vue";
import {useStore} from "vuex";
import {useAsyncDropdownHelper} from "@/services/utils/asyncDropdownHelper";
import AddTempleModal from '@/components/molecule/company/hospital/prescription/AddTempleModal.vue';
import handleTemplate from '@/services/modules/all-modules/template'
import AdvanceReceiptSelectionModal
    from "@/components/molecule/company/inventory/electronic-invoice/AdvanceReceiptSelectionModal.vue";
import handleDropdowns from '@/services/modules/dropdowns';
import MoneyReceiptForm from "@/components/molecule/company/inventory/electronic-invoice/MoneyReceiptForm.vue";
import BarcodeScanInput from "@/components/molecule/input-field/BarcodeScanInput.vue";

const router = useRouter()
const route = useRoute()
const store = useStore()
let prefix = ref('')
let serial = ref('')

const showError =  inject('showError');
const showSuccess =  inject('showSuccess');

const { fetchProductList, fetchAccountHead, ...rest } = handlePurchase()
const { fetchBusinessList } = handleCBusinesses()
const { fetchBusinessLocationsList } = handleBusinessesLocations()
const { fetchContactProfiles, fetchContactAdvanceReceipts, fetchSingleContactProfile } = handleContact()
const { fetchProjects } = handleProjects()
const { fetchCostCentreList } = handleCostCentres()
const { formatPatientLabel } = useAsyncDropdownHelper();
const { removeTemplate } = handleTemplate();
const { fetchDropdownList } = handleDropdowns();

let loader =ref(false)
let productLoader =ref(false)
let saveButtonLoader=ref(false)
let saveNewButtonLoader =ref(false)
let products = ref([])
let accountHeads = ref([])
let business = ref([])
let locations = ref([])
let accountPayable = ref([])
let vatPayable = ref([])
let fetchedFromAPI = ref(false)
let isInitialLoad = ref(false)
let projects = ref([])
let costCentres = ref([])
let contactProfile = ref(null)
let salesPerson = ref(null)
let contactType = ref('');
const advanceReceiptList = ref([]);
let salesAccountHeads = ref([])
const grandTotal = ref(null);
const offerLoadingCount = ref(0);
let lastScanRowKey = 0;
const rewardBalance = ref(0);
const originalPointsRedeemed = ref(0);
const rewardPointsAccountHeads = ref([]);
const existingReceipt = ref(null);

const receiptLocked = computed(() => !! existingReceipt.value && !! existingReceipt.value.is_locked)

const availableRewardBalance = computed(() => {
  return Number(rewardBalance.value) + Number(originalPointsRedeemed.value)
})

watch(contactProfile, () => {
  if (! contactProfile.value) {
    return
  }
  const patientQuery = `?company_id=${route.params.companyId}&type=customer&reward_balance=1`;
  fetchSingleContactProfile(contactProfile.value.id, patientQuery).then(res => {
    if (res.data) {
      rewardBalance.value = res.data.reward_balance;
    }
  }).catch(() => showError('Failed to load reward balance'))
})

const getDropDownQuery = () => {
  return `?company_id=${companyId.value}&is_account_heads=1&slags[]=reward_points`;
}

onMounted(async () => {
    loader.value = true;
    const companyQuery = `?company_id=${companyId.value}`
    let projectQuery = companyQuery + '&with_donors=1';
    const invoiceQuery = companyQuery + '&get_discount_data=1';
    const productRes = fetchProductList(companyQuery)
    const accountHeadRes = fetchAccountHead(companyQuery)
    const businessRes = fetchBusinessList(companyQuery)
    const businessLocationRes = fetchBusinessLocationsList(companyQuery)
    const payableRes = rest.fetchAccountReceivable(companyQuery)
    const vatPayableRes = rest.fetchVatPayable(companyQuery)
    const fetchSingleSalesBill = rest.fetchSalesBill(route.params.salesId, invoiceQuery)
    const projectRes = fetchProjects(projectQuery)
    const costCenterRes = fetchCostCentreList(companyQuery)
    const salesAccountHeadsRes = rest.getAccountHeadBySlag("sales_accounts", companyQuery)
    const dropdownRes = fetchDropdownList(getDropDownQuery());

    Promise.all([
        productRes.then(res=> {
            if(res.data) products.value = res.data
        }),
        accountHeadRes.then(res=> {
            if(res.data) accountHeads.value = res.data
        }),
        businessRes.then(res=> {
            if(res.data) business.value = res.data
        }),
        businessLocationRes.then(res=> {
          if(res.data) locations.value = res.data
        }),
        projectRes.then(res=> {
          if(res.data) projects.value = res.data
        }),
        costCenterRes.then(res=> {
          if(res.data) costCentres.value = res.data
        }),
        payableRes.then(res=> {
            if(res.data) accountPayable.value = res.data
            if(res.data && res.data.length) {
                formData.value.account_head_id = res.data[0].id
            }
        }),
        vatPayableRes.then(res=> {
          if(res.data) vatPayable.value = res.data
          if(res.data && res.data.length) {
            formData.value.vat_payable_account_head_id = res.data[0].id
          }
        }),
        salesAccountHeadsRes.then(res => {
            if(res.data) salesAccountHeads.value = res.data
        }),
        dropdownRes.then(res => {
          if (!res.status) return;
          if(res.data.account_head_list_by_slag.reward_points) {
            rewardPointsAccountHeads.value = res.data.account_head_list_by_slag.reward_points;
          }
        }),
        fetchSingleSalesBill.then(res => {
          if (!res.data){
            return
          }

          let voucher = editVoucherNumber(res.data.bill_number);
          prefix.value = voucher.prefix;
          serial.value = voucher.serial;
          fetchedFromAPI.value = true
          isInitialLoad.value = true
          formData.value = res.data
          contactProfile.value = res.data.contact;
          salesPerson.value = res.data.sales_person;
          formData.value.adjustment_amount = res.data.round_up_discount;
          formData.value.points_redeemed = Number(res.data.points_redeemed) || null;
          originalPointsRedeemed.value = Number(res.data.points_redeemed) || 0;

          if(res.data.discount_ledger && res.data.discount_ledger.account_head_id) {
            formData.value.discount_head_id = res.data.discount_ledger.account_head_id;
          }
          if(res.data.reward_point_ledger && res.data.reward_point_ledger.account_head_id) {
            formData.value.liability_head_id = res.data.reward_point_ledger.account_head_id;
          }

          if(res.data.has_item_detail) {
            formData.value.item_details = res.data.general.map(item => ({
              ...item,
              saved_tax_rate: getSavedTaxRate(item)
            }))
            formData.value.has_item_detail = true
          }

          if(!res.data.has_item_detail) {
            formData.value.account_details = res.data.ledgers
            formData.value.has_item_detail = false
          }

          if (res.data.receipt_generals){
            formData.value.advance_amount = res.data.receipt_generals.reduce((sum, item) => sum + item.paid_amount, 0);
          }

          applyExistingReceipt(res.data.editable_receipt)
        })
    ])
    .then(async () => {
      applyDefaultRewardPointHead()
      loader.value=false
      await nextTick()
      applyExistingPayment()
    })
    .catch(()=>{loader.value=false})
})

const applyDefaultRewardPointHead = () => {
  if (! formData.value.points_redeemed || formData.value.liability_head_id) {
    return
  }
  if (! rewardPointsAccountHeads.value || ! rewardPointsAccountHeads.value.length) {
    return
  }
  formData.value.liability_head_id = rewardPointsAccountHeads.value[0].id
}

const applyExistingReceipt = (receipt) => {
  existingReceipt.value = receipt || null
  if (! receipt) return
  formData.value.mop_account_head_id = receipt.mop_account_head_id
  formData.value.vat_challan_account_head_id = receipt.vat_challan_account_head_id
  formData.value.ait_challan_account_head_id = receipt.ait_challan_account_head_id
  formData.value.discount_account_head_id = receipt.discount_account_head_id
  formData.value.vat_challan_amount = receipt.vat_challan_amount
  formData.value.ait_challan_amount = receipt.ait_challan_amount
  formData.value.discount_amount = receipt.discount_amount
  formData.value.receipt_reference = receipt.receipt_reference
}

const applyExistingPayment = () => {
  if (! existingReceipt.value) return
  formData.value.payment = existingReceipt.value.payment
}

const getSavedTaxRate = (source) => {
  if (! source.tax_rate_id) return null
  return {
    id: source.tax_rate_id,
    name: source.tax_rate_name,
    rate: source.tax_rate_rate
  }
}

const companyId = computed(() => {
    return route.params.companyId
})

let formData = ref({
    company_id: companyId,
    contact_profile_id: null,
    account_head_id: null,
    vat_payable_account_head_id: null,
    business_id: null,
    project_id: null,
    cost_centre_id: null,
    location_id: null,
    status: 'active',
    bill_number: '',
    date: '',
    has_item_detail: true,
    description: '',
    account_details: [],
    item_details: [
        {
            product_id: null,
            quantity: 1,
            rate: '',
            discount_amount: 0,
            discount_percent: 0,
            vat: 0,
            vat_amount: 0,
            description: "",
            business_id: null,
            project_id: null,
            cost_centre_id: null,
            tax_rate_id: null
        }
    ],
})
provide('formData', formData);

const hasItemDetails = computed(() => {
    return formData.value.has_item_detail
})

const itemsDetails = computed(() => {
    return formData.value.item_details
})

const accountsDetails = computed(() => {
    return formData.value.account_details
})

const isItem = computed(() => {
    return !!formData.value.has_item_detail
})

const selectedCustomerId = computed(() => formData.value.contact_profile_id)
const discountAmount = computed(() => formData.value.adjustment_amount);
const pointsRedeemed = computed(() => formData.value.points_redeemed);
const commissionPercent = computed(() => formData.value.commission_percent)
const isOfferLoading = computed(() => offerLoadingCount.value > 0)
const scanQuery = computed(() => ({ location_id: formData.value.location_id }))
const scanPlaceholder = computed(() => {
    if (! formData.value.location_id) return 'Select warehouse first'
    return 'Scan or type barcode / SKU, press Enter'
})

const onOfferLoading = (loading) => {
  if (loading) {
    offerLoadingCount.value++;
    return;
  }

  offerLoadingCount.value = Math.max(0, offerLoadingCount.value - 1);
}

const subTotal = computed(() => {
    let subTotal=0
    if(formData.value.has_item_detail) {
        formData.value.item_details.map(item => {
            subTotal += parseFloat((item.quantity * item.rate) - item.discount_amount)
        })
    }
    if(!formData.value.has_item_detail && formData.value.account_details) {
        formData.value.account_details.map(item => {
            if(item.amount) {
                subTotal += parseFloat(item.amount)
            }
        })
    }

    return subTotal.toFixed(4)
})

const totalVAT = computed(() => {
    let vat=0
    if(formData.value.has_item_detail) {
        formData.value.item_details.map(item => {
          if(item.vat_amount) {
            vat += parseFloat(item.vat_amount)
          }
        })
    }
    if(!formData.value.has_item_detail && formData.value.account_details) {
        formData.value.account_details.map(item => {
            if(item.vat_amount) {
                vat += parseFloat(item.vat_amount)
            }
        })
    }

    return vat.toFixed(4)
})

const beforeAdjTotal = computed(() => (parseFloat(subTotal.value) + parseFloat(totalVAT.value)).toFixed(4));

const total = computed(() => {
    return (parseFloat(subTotal.value) + parseFloat(totalVAT.value) - parseFloat(formData.value.advance_adj_amount)).toFixed(4)
})

watch(hasItemDetails, (newValue) => {
    if(!newValue) {
      if(fetchedFromAPI.value === false){
        delete formData.value.item_details
        formData.value.account_details = [{
            account_head_id: null,
            vat_payable_account_head_id: null,
            amount: '',
            discount_amount: 0,
            discount_percent: 0,
            vat: 0,
            vat_amount: 0,
            description: '',
            taxable_amount: null,
            tax_rate: null
        }]
      } else {
          fetchedFromAPI.value = false
      }
    }
    if(newValue) {
      if(fetchedFromAPI.value === false) {
        delete formData.value.account_details
        formData.value.item_details = [{
            product_id: null,
            quantity: 1,
            rate: '',
            vat: 0,
            vat_amount: 0,
            discount_amount: 0,
            discount_percent: 0,
            description: "",
            tax_rate_id: null
        }]
      } else {
          fetchedFromAPI.value = false
      }
    }
})

watch(contactProfile, (newValue) => {
    if (newValue) {
        formData.value.contact_profile_id = newValue.id;
        return;
    }

    formData.value.contact_profile_id = null;
})

watch(salesPerson, (newValue) => {
    if (newValue) {
        formData.value.sales_person_id = newValue.id;
        return;
    }

    formData.value.sales_person_id = null;
})

watch(selectedCustomerId, (newValue) => {
    const companyQuery = `?company_id=${companyId.value}`
    advanceReceiptList.value = []

    if(newValue) {
        fetchContactAdvanceReceipts(newValue, companyQuery).then(res => {
            if (res.data && res.data.length) {
                advanceReceiptList.value = res.data
            }
        }).catch(() => showError("Something went wrong"))
    }
})

watch(() => formData.value.points_redeemed, (newValue) => {
  if (isInitialLoad.value) {
    isInitialLoad.value = false;
    return;
  }

  let val = Number(newValue) || 0;

  if (val <= 0) {
    formData.value.points_redeemed = null;
    return;
  }

  if (val > availableRewardBalance.value) {
    showError('Points redeemed cannot be more than reward balance');
    val = availableRewardBalance.value;
  }

  const billAmount = Number(total.value) - Number(discountAmount.value || 0);

  if (val > billAmount) {
    showError('Points redeemed cannot be more than net bill amount');
    val = billAmount;
  }

  formData.value.points_redeemed = val;

  if (val > 0 && ! formData.value.liability_head_id) {
    formData.value.liability_head_id = rewardPointsAccountHeads.value
        && rewardPointsAccountHeads.value[0]
        && rewardPointsAccountHeads.value[0].id;
  }
});

watch(total, (newValue) => {
    grandTotal.value = total.value - (discountAmount.value || 0) - (pointsRedeemed.value || 0);

    if(commissionPercent.value) {
        formData.value.commission_amount = (newValue/100) * commissionPercent.value;
        return;
    }

    formData.value.commission_amount = 0;
})

watch(discountAmount, (newValue, oldValue) => {
    if (! newValue || newValue < 0) {
        grandTotal.value = total.value - (pointsRedeemed.value || 0);
        formData.value.adjustment_amount = null;
        return;
    }

    if (newValue !== oldValue) {
        grandTotal.value = total.value - discountAmount.value - (pointsRedeemed.value || 0)
    }
})

watch(pointsRedeemed, (newValue, oldValue) => {
  if (! newValue || newValue < 0) {
    grandTotal.value = total.value - (discountAmount.value || 0);
    formData.value.points_redeemed = null;
    return;
  }

  if (newValue !== oldValue) {
    grandTotal.value = total.value - (discountAmount.value || 0) - pointsRedeemed.value
  }
})

watch(grandTotal, () => {
  applyExistingPayment()
}, { flush: 'post' })

const openAdvanceModal = () => {
    if(!selectedCustomerId.value) {
        showError("Please select customer first")
        return;
    }

    if(
        !advanceReceiptList.value ||
        (Array.isArray(advanceReceiptList.value) && !advanceReceiptList.value.length)
    ) {
        showError("No advance receipts found");
        return;
    }

    store.state.isAdvanceModalOpen = true
}

const updateAdjustmentAmount = () => {

    if (total.value <= 0) {
        formData.value.adjustment_amount = null;
        return;
    }

    formData.value.adjustment_amount = parseFloat((total.value - grandTotal.value).toFixed(4));
}

const changeTemplateStatus = (isExists) => {
    formData.value.template_log_exists = isExists;
}

const onRemoveTemplate = async () => {

    if(! confirm('Are you sure you want to remove this template?')) return;

    let query = getQuery();
    query += '&template_type=sale';

    loader.value = false

    await removeTemplate(query, formData.value.id).then((res) => {
        if (!res.status) return showError(res.message);
        changeTemplateStatus(false);
        return showSuccess(res.message);
    }).catch(() => {
        showError('Something went wrong')
    }).finally(() => {
        loader.value = false
    })
}

const getQuery = () => {
    let query = `?company_id=${companyId.value}`;
    return query;
}

const onOpenContactSearchModal = (type) => {
    contactType.value = type
    store.state.isModalOpenThree = true;
}

const onClickToMakeTemplate = () => {
    store.state.isModalOpenTwo = true;
}

const getRouteName = () => {
    if (route.query.redirect_route && route.query.redirect_route !== '') {
        return route.query.redirect_route;
    }

    return 'sales-list';
}

function navigateToListPage() {
    router.push({name: getRouteName(), params: route.params, query: route.query})
}

function removeBill(index) {
    if(hasItemDetails.value) {
        formData.value.item_details.splice(index, 1)
    }
    if(!hasItemDetails.value) {
        formData.value.account_details.splice(index, 1)
    }
}

function addNewBill() {
    if(hasItemDetails.value) {
        formData.value.item_details.push({
            product_id: null,
            quantity: 1,
            rate: '',
            discount_amount: 0,
            discount_percent: 0,
            vat: 0,
            vat_amount: 0,
            business_id: null,
            project_id: null,
            description: '',
            tax_rate_id: null
        })
        return;
    }

    formData.value.account_details.push({
        account_head_id: null,
        vat_payable_account_head_id: null,
        amount: '',
        discount_amount: 0,
        discount_percent: 0,
        business_id: null,
        project_id: null,
        vat: 0,
        vat_amount: 0,
        description: '',
        taxable_amount: null,
        tax_rate: null
    })
}

function onBarcodeScanned(product) {
    const existingLine = formData.value.item_details.find(item => item.product_id === product.id)
    if (existingLine) {
        showError(`${product.name} is already added`)
        return
    }

    addScannedLine(product)
}

function addScannedLine(product) {
    const lines = formData.value.item_details
    while (lines.length && ! lines[lines.length - 1].product_id) {
        lines.pop()
    }

    lastScanRowKey += 1
    lines.push({
        row_key: `scan-${lastScanRowKey}`,
        product_id: product.id,
        quantity: null,
        rate: '',
        discount_amount: 0,
        discount_percent: 0,
        vat: 0,
        vat_amount: 0,
        business_id: null,
        project_id: null,
        description: '',
        tax_rate_id: null,
        product: {
            id: product.id,
            name: product.name,
            product_type: product.product_type
        }
    })
}

function handleSubmit(redirect=false) {
    if (isOfferLoading.value) {
      showError('Please wait, checking product offer');
      return;
    }

    if (! formData.value.vat_payable_account_head_id){
      showError('Please select a VAT/GST payable account head');
      return;
    }
    if(redirect) {
        saveButtonLoader.value = true
    } else {
        saveNewButtonLoader.value = true
    }
    formData.value.bill_number = prefix.value+'-'+serial.value
    if(!formData.value.date) formData.value.date = new Date().toISOString().split('T')[0]
    let copyFormData = JSON.parse(JSON.stringify(formData.value))
    copyFormData.has_item_detail = formData.value.has_item_detail ? 1 : 0
    copyFormData.sync_invoice_receipt = 1
    if(isItem.value) {
        delete copyFormData.account_details
        copyFormData.item_details = formData.value.item_details
    }else {
         delete copyFormData.item_details
        copyFormData.account_details = formData.value.account_details
    }
    rest.updateSalesBill(route.params.salesId,  copyFormData)
    .then(res => {
        saveButtonLoader.value = false
        saveNewButtonLoader.value = false
        productLoader.value = false
        if(res.status) {
            showSuccess(res.message)
            if(redirect) navigateToListPage()
            resetForm()
        }
        if(!res.status) {
            showError(res.message)
        }
    })
    .catch( (e) => {
        saveButtonLoader.value = false
        saveNewButtonLoader.value = false

        if (e.response.data) {
            showError(e.response.data.message)
        }
    })
}

// have to refactor
function resetForm() {
    if(!isItem.value) {
        formData.value.account_details = [{
            account_head_id: null,
            vat_payable_account_head_id: null,
            amount: '',
            vat: 0,
            vat_amount: 0,
            description: '',
            discount_amount: 0,
            discount_percent: 0,
            taxable_amount: null,
            business_id: null,
            project_id: null,
            tax_rate: null
        }]
    }
    if(isItem.value) {
        formData.value.item_details = [{
            product_id: null,
            quantity: 1,
            rate: '',
            vat: 0,
            vat_amount: 0,
            discount_amount: 0,
            discount_percent: 0,
            business_id: null,
            project_id: null,
            description: "",
            tax_rate_id: null
        }]
    }
}

const onSearchContact = (contact) => {
    if(contactType.value === 'sales_person') {
        salesPerson.value = contact
        return;
    }
    contactProfile.value = contact
}

</script>

<style scoped>
.receipt-locked {
    pointer-events: none;
    opacity: .6;
}
</style>
